// How the upload page names a sheet's event and source, the same in the edit view's header and the upload history.
import { SheetSession, UploadOrigin } from "./types";
import { md } from "./ui";

export const isGame = (s: SheetSession) => s.kind === "game";

/** "vs GSW" at home, "at GSW" away. */
export const versus = (s: SheetSession) =>
  s.opponent ? `${s.home === false ? "at" : "vs"} ${s.opponent}` : "";

/** "PRACTICE" or "GAME · VS GSW" / "GAME · AT GSW". */
export const eventText = (s: SheetSession) =>
  isGame(s)
    ? `GAME${s.opponent ? ` · ${versus(s).toUpperCase()}` : ""}`
    : "PRACTICE";

/** A game in the event picker: "10/7 · VS GSW". */
export const gameOption = (s: SheetSession) =>
  `${s.date ? md(s.date) : ""} · ${versus(s).toUpperCase()}`;

/** For sentences: "practice 9/30" or "the game vs GSW 10/7" (a game's own label, which reads that way). */
export const eventPhrase = (s: SheetSession) =>
  isGame(s)
    ? `the game ${s.label ?? `${s.opponent ? `${s.home === false ? "at" : "vs"} ${s.opponent} ` : ""}${s.date ? md(s.date) : ""}`}`.trim()
    : `practice ${s.date ? md(s.date) : ""}`.trim();

// Uploads from before the origin column were all a person's (a file or a sheet typed in).
export const originOf = (s: SheetSession): UploadOrigin =>
  s.origin ?? "uploaded";

export const ORIGIN_TEXT: Record<UploadOrigin, string> = {
  tracking: "TRACKING",
  edited: "EDITED",
  uploaded: "UPLOADED",
};

/** A game's crashing whose numbers a person saved: tracking leaves it alone until someone reverts it. */
export const canRevert = (s: SheetSession & { sheet: string }) =>
  isGame(s) && s.sheet === "crashing" && originOf(s) !== "tracking";
